import * as VueGoogleMaps from 'vue2-google-maps'
import { get } from 'lodash'

export default function install (Vue) {
  Vue.use(VueGoogleMaps, {
    load: {
      key: get(process.env, 'GOOGLE_MAPS_KEY', null)
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/maps/maps.js